export default "__VITE_ASSET__YKW_UrmW__"